/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PunchoutStatus } from './';
import {
    PunchoutStatusFromJSON,
    PunchoutStatusFromJSONTyped,
    PunchoutStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface QuotePunchoutDetailsResource
 */
export interface QuotePunchoutDetailsResource {
    /**
     * 
     * @type {PunchoutStatus}
     * @memberof QuotePunchoutDetailsResource
     */
    status: PunchoutStatus;
    /**
     * 
     * @type {boolean}
     * @memberof QuotePunchoutDetailsResource
     */
    punchoutSessionActive: boolean;
    /**
     * 
     * @type {string}
     * @memberof QuotePunchoutDetailsResource
     */
    procurementAppName: string;
    /**
     * 
     * @type {string}
     * @memberof QuotePunchoutDetailsResource
     */
    procurementAppUrl: string;
}

/**
 * Check if a given object implements the QuotePunchoutDetailsResource interface.
 */
export function instanceOfQuotePunchoutDetailsResource(value: object): value is QuotePunchoutDetailsResource {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('punchoutSessionActive' in value) || value['punchoutSessionActive'] === undefined) return false;
    if (!('procurementAppName' in value) || value['procurementAppName'] === undefined) return false;
    if (!('procurementAppUrl' in value) || value['procurementAppUrl'] === undefined) return false;
    return true;
}

export function QuotePunchoutDetailsResourceFromJSON(json: any): QuotePunchoutDetailsResource {
    return QuotePunchoutDetailsResourceFromJSONTyped(json, false);
}

export function QuotePunchoutDetailsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuotePunchoutDetailsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'status': PunchoutStatusFromJSON(json['status']),
        'punchoutSessionActive': json['punchoutSessionActive'],
        'procurementAppName': json['procurementAppName'],
        'procurementAppUrl': json['procurementAppUrl'],
    };
}

export function QuotePunchoutDetailsResourceToJSON(value?: QuotePunchoutDetailsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': PunchoutStatusToJSON(value['status']),
        'punchoutSessionActive': value['punchoutSessionActive'],
        'procurementAppName': value['procurementAppName'],
        'procurementAppUrl': value['procurementAppUrl'],
    };
}

